export const menuItemsData = [
    {
        title: 'Hem',
        url: '',
    },
    {
        title: 'Inbjudan och anmälan',
        submenu: [
            {
                title: 'Inbjudan',
                url: 'inbjudan',
            },
            {
                title: 'Anmälan och betalning',
                url: 'anmalan',
            },
            {
                title: 'Laganmälan och betalning',
                url: 'laganmalan',
            },
            {
                title: 'Anmälda',
                url: 'anmalda',
            },
            {
                title: 'Bansträckning',
                url: 'https://www.jogg.se/Tavling/Tavling.aspx?id=659462',
            },
        ],
    },
    {
        title: 'Tävling',
        submenu: [
            {
                title: 'PM - tävlingsinfo',
                url: 'pm',
            },
            {
                title: 'Startlista',
                url: 'startlista',
            },
            {
                title: 'Live-resultat',
                url: 'liveresultat',
            },
            {
                title: 'Bansträckning',
                url: 'https://www.jogg.se/Tavling/Tavling.aspx?id=659462',
            },
        ],
    },
    {
        title: 'Kontakt',
        submenu: [
            {
                title: 'Facebook',
                url: 'https://www.facebook.com/pages/Kanall%C3%B6pet/554593964639517?fref=ts',
            },
            {
                title: 'E-post',
                url: 'mailto:kanallopet@boremail.com',
            },
        ],
    },
    {
        title: 'Arkiv',
        submenu: [
            {
                title: 'Bildarkiv',
                url: 'bildarkiv',
            },
            {
                title: 'Historik',
                url: 'historik',
            },
            {
                title: 'Resultatlistor',
                url: 'resultatlistor',
            },
        ],
    },
    {
        title: 'Min sida',
        url: 'minsida',
    },
];